var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryGreyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V4.90682C0 5.05668 0.0109883 5.20397 0.0322033 5.34794C0.0109883 5.49191 0 5.6392 0 5.78906V16.998C0 18.6549 1.34315 19.998 3 19.998H22.5631C24.22 19.998 25.5631 18.6549 25.5631 16.998V5.78906C25.5631 4.13221 24.22 2.78906 22.5631 2.78906H11.6123C11.5041 1.23063 10.2055 0 8.6196 0H3Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryGreyFolder);
export default __webpack_public_path__ + "static/media/library-grey-folder.cb90f019b064fb48590f89c79eee4325.svg";
export { ForwardRef as ReactComponent };